var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"reportContainer",staticStyle:{"height":"calc(100vh - 63px)","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }